import React from 'react';

import { SdmTypography, SdmSpacer } from 'components';
import {
  BiggerCardBrand,
  BiggerCardUser,
  BiggerCardAdmin,
} from 'components/Cards';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Grid from '@material-ui/core/Grid';

const BrCardsContainer = ({
  date,
  items,
  functions,
  email,
  isBrand = false,
  isAdmin = false,
}) => {
  const mediaTheme = useTheme();
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  return (
    <Grid container>
      {!isSmDown && <SdmSpacer height={30} />}
      <Grid item xs={12}>
        <SdmTypography variant={isXsDown ? 'h2' : 'h1'}>{date}</SdmTypography>
      </Grid>
      <SdmSpacer height={30} />
      {items &&
        items.map((i, idx) => {
          return (
            <Grid item xs={12} key={idx}>
              {isBrand ? (
                <BiggerCardBrand
                  cardInformations={i}
                  isSmDown={isSmDown}
                  isXsDown={isXsDown}
                  functions={functions}
                />
              ) : isAdmin ? (
                <BiggerCardAdmin
                  cardInformations={i}
                  isSmDown={isSmDown}
                  isXsDown={isXsDown}
                />
              ) : (
                <BiggerCardUser
                  cardInformations={i}
                  isSmDown={isSmDown}
                  isXsDown={isXsDown}
                  functions={functions}
                  email={email}
                />
              )}
            </Grid>
          );
        })}
    </Grid>
  );
};

export default BrCardsContainer;
